import React, { useEffect } from 'react';

import i18next from 'i18next';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CronJobName } from '../CronJobsCRUDForm.types';

import {
  ControlledDatePicker,
  ControlledSelect
} from 'components/shared/ControlledFields';
import { TasksCronJobsFormContentBox } from '../CronJobsCRUDForm.styles';
import { JobNameSelect } from '../JobNameSelect';

const reportOptions = [
  { value: 'dtr', label: 'Arbeidstijden Wet' },
  { value: 'capplan', label: 'Capaciteit Plan' }
];
const getPeriodOptions = (reportDefition: 'dtr' | 'capplan' | undefined) =>
  !reportDefition
    ? []
    : reportDefition === 'dtr'
    ? [
        { value: '1', label: i18next.t('nextMonth') },
        { value: '0', label: i18next.t('thisMonth') },
        { value: '-1', label: i18next.t('previousMonth') }
      ]
    : [
        {
          value: 'MONTH',
          label: i18next.t('adminPortal.procedures.reports.month')
        },
        {
          value: 'WEEK',
          label: i18next.t('adminPortal.procedures.reports.week')
        }
      ];

interface Props {
  selectedJobType: CronJobName;
  changeJobType: React.Dispatch<React.SetStateAction<CronJobName>>;
}

export const TasksCronJobsFormContent: React.FC<Props> = ({
  selectedJobType,
  changeJobType
}) => {
  const { t } = useTranslation();
  const { control, setValue, watch, unregister } = useFormContext();
  const reportDefition = watch('config.reportDefinitionId');

  // dtr-calculation and roster-publication are both scheduled for every tenant, which is
  // something the label has to say - so JobNameSelect labels them from the API's scopes.
  const jobNames: CronJobName[] = [
    'report',
    'dtr-calculation',
    'roster-publication'
  ];

  useEffect(() => {
    if (!reportDefition || reportDefition !== 'capplan') {
      unregister('config.valid_from');
      unregister('config.valid_to');
      unregister('config.month_or_week');
    } else if (reportDefition === 'capplan') {
      unregister('config.period');
    }
  }, [reportDefition]);

  return (
    <TasksCronJobsFormContentBox>
      <JobNameSelect
        jobNames={jobNames}
        selectedJobType={selectedJobType}
        onSelected={(value) => {
          changeJobType(value);
          setValue('jobName', value);
        }}
      />
      {selectedJobType === 'report' && (
        <>
          <ControlledSelect
            variant="outlined"
            label={t('cronJobs.form.reportDefinition')}
            control={control}
            name="config.reportDefinitionId"
            options={reportOptions}
          />
          <ControlledSelect
            variant="outlined"
            label={t('cronJobs.form.period')}
            control={control}
            name={
              reportDefition === 'dtr'
                ? 'config.period'
                : 'config.month_or_week'
            }
            options={getPeriodOptions(reportDefition)}
          />
          {reportDefition === 'capplan' && (
            <>
              <ControlledDatePicker
                required
                fullWidth
                variant="outlined"
                control={control}
                name={'config.valid_from'}
                label={t('validFrom')}
              />
              <ControlledDatePicker
                required
                fullWidth
                variant="outlined"
                control={control}
                name={'config.valid_to'}
                label={t('validTo')}
              />
            </>
          )}
        </>
      )}
    </TasksCronJobsFormContentBox>
  );
};
